import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { IApiParams } from '../../interface/IApiParams';
import { getApiFile } from '../getApiFile';

export const apiGetDaysSummary = async (
  ids: string[],
  datetime?: string,
  groupName?: string
) => {
  const params: IApiParams = {
    url: '/archive/getDaysSummary.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
    timeout: 120000,
  };
  return getApiFile(params, 'POST', {
    ids,
    datetime,
    groupName,
  });
};
